'use strict';
module.exports = require('./ProgressSpinner.vue');